import React from 'react'
import "./Footer.css"
import { FaFacebook, FaLinkedin, FaInstagram, FaTwitter } from 'react-icons/fa'

const Footer = () => {
    return (
        <footer id="footer">


            <div className="footer__socials">

                <a href="https://www.linkedin.com/in/john-paul-salazar-224659193/" target='_blank' rel='noopener noreferrer'>
                    <FaLinkedin size={30} style={{ color: "#4db5ff" }} />
                </a>

                <a href="https://www.facebook.com/johnpaul.d.salazar" target='_blank' rel='noopener noreferrer'>
                    <FaFacebook size={30} style={{ color: "#4db5ff" }} />
                </a>

                <a href="https://www.instagram.com/jpaul.salazar/" target='_blank' rel='noopener noreferrer'>
                    <FaInstagram size={30} style={{ color: "#4db5ff" }} />
                </a>

                {/* <a href="https://twitter.com/pauldsalazar" target='_blank' rel='noopener noreferrer'>
                    <FaTwitter size={30} style={{ color: "#4db5ff" }} />
                </a> */}
            </div>
            <div className="footer_copyright">
                <small> © John Paul Salazar. </small>
                <small> All rights reserved.</small>
            </div>
        </footer>
    )
}

export default Footer